export default __webpack_public_path__ + "static/media/ico_earth.5dde438a.svg";